import BaseService from '../services/base.service';

export const base = {
  namespaced: true,
  state: {
    profileList: [],
  },
  actions: {
    async getPlanList({ commit }) {
      const resp = await BaseService.getPlanList();
      if (resp.status === 200) {
        commit('SET_PLAN_LIST', resp.data);
      }
      return resp.status;
    },
  },
  mutations: {
    SET_PLAN_LIST(state, planList) {
      state.planList = planList;
    },
  },
};
